<template>
  <Dialog ref="dialog"
          width="460px"
          icon="fas fa-truck"
          @confirm="changePlate"
          @closed="cleanDialog"
          :show-confirm="true"
          :title="`Cambio de patente: ${oldPlate}`">
    <span class="label-enterprise">Seleccione empresa</span>
    <el-select  v-model="enterpriseId"
                size="mini"
                @change="getPlates"
                filterable
                placeholder="Ej: nombre empresa">
      <el-option  v-for="enterprise in enterprises"
                  :key="enterprise.id"
                  :label="enterprise.name"
                  :value="enterprise.id"/>
    </el-select>
    <div class="selectPlate">
      <span>Seleccione patente</span>
      <el-select  v-model="plateId"
                  size="mini"
                  :disabled="plates.length < 1"
                  filterable
                  placeholder="Ej: PAT-123"
                  class="mini-loader"
                  v-loading="loadPlates">
        <el-option  v-for="plate in plates"
                    :key="plate.id"
                    :label="plate.patent"
                    :value="plate.id"/>
      </el-select>
    </div>
  </Dialog>
</template>

<script>
import { cachedAPIRequest } from '../../../mixins/cacheDim';
import { apiRequest } from '../../../backend/vue-axios/axios';
import Dialog from '../base/Dialog.vue';

export default {
  name: 'DialogChangePlate',
  components: {
    Dialog,
  },
  data() {
    return {
      routeId: null,
      oldPlate: '-',
      plateId: null,
      plates: [],
      enterprises: [],
      loadPlates: false,
      enterpriseId: null,
    };
  },
  mounted() {
    this.getEnterprises();
  },
  methods: {
    showChangeDialog(routeId, plate) {
      this.routeId = routeId;
      this.oldPlate = plate;
      this.$refs.dialog.visible(true);
    },
    cleanDialog() {
      Object.assign(this, {
        plates: [],
        oldPlate: '-',
        routeId: null,
        plateId: null,
        loadPlates: false,
        enterpriseId: null,
      });
    },
    getEnterprises() {
      cachedAPIRequest({
        module: 'planning',
        service: 'enterprises',
        params: { limit: 6000 },
      }).then((response) => {
        this.enterprises = response.data;
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar las empresas',
        });
      });
    },
    getPlates() {
      this.loadPlates = true;
      cachedAPIRequest({
        module: 'crud',
        service: 'get_vehicles',
        params: {
          limit: 1000,
          vehicles_active: true,
          vehicles_enterprises_id: this.enterpriseId,
        },
      }).then((response) => {
        this.plates = response.data.sort((a, b) => (b.patent > a.patent ? -1 : 1));
        this.plateId = null;
        this.loadPlates = false;
        if (this.plates.length < 1) {
          this.$notify.warning({
            title: 'Advertencia',
            message: 'Empresa sin patentes activas',
          });
        }
      }).catch(() => {
        this.loadPlates = false;
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar las patentes',
        });
      });
    },
    changePlate() {
      const parameters = {
        plate_id: this.plateId,
      };
      apiRequest({
        module: 'planning',
        service: 'set_vehicle_on_routev3',
        pathparam: { id: this.routeId },
        params: parameters,
      }).then(() => {
        this.$notify({
          type: 'success',
          title: 'OK',
          message: 'Patente modificada',
        });
        this.$emit('getDatatracing', [this.routeId]);
        this.$refs.dialog.visible(false);
      }).catch((error) => {
        this.$refs.dialog.loading(false);
        let errorMessage = 'Verifique los datos seleccionados';
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }
        this.$notify({
          type: 'error',
          title: 'Error al cambiar patente',
          message: errorMessage,
        });
      });
    },
  },
};

</script>

<style lang="scss" scoped>
  .selectPlate { margin-top: 20px; }
  .content {
    span {
      font-size: 12px;
      color: #606166;
    }
    padding: 0 20px;
    text-align: left;
  }
</style>
